import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined';
import type { SvgIconComponent } from '@mui/icons-material';
import type { IDocumentosContrato } from '@/shared/interfaces/erp/tickets-soporte-clientes';

export type CategoriaDocumentoKey = keyof Omit<IDocumentosContrato, 'id_contrato' | 'softnet_disponible'>;
export type CategoriaDocumentoColor = 'primary' | 'info' | 'secondary' | 'success';

export interface CategoriaDocumento {
  key: CategoriaDocumentoKey;
  label: string;
  icon: SvgIconComponent;
  color: CategoriaDocumentoColor;
}

// Orden y nombre de las tarjetas del tab. `key` es el campo de la respuesta del backend.
export const CATEGORIAS_DOCUMENTOS: CategoriaDocumento[] = [
  { key: 'contratos',            label: 'Contratos',            icon: DescriptionOutlinedIcon,    color: 'primary' },
  { key: 'actualizacion_debito', label: 'Actualización débito', icon: AccountBalanceOutlinedIcon, color: 'info' },
  { key: 'adendas',              label: 'Adendas',              icon: EditNoteOutlinedIcon,       color: 'secondary' },
  { key: 'varios',               label: 'Varios',               icon: FolderOutlinedIcon,         color: 'success' },
];

// El backend no envia el tipo de archivo: se deduce por la extension de la URL
// (la foto del RUC puede ser imagen; el resto son PDF).
export const esImagen = (url: string) => /\.(png|jpe?g|gif|webp)(\?.*)?$/i.test(url);
